var Cms = {
	node :null,
	current: null,
	vue: null,

	init: function() {
		//console.log("PLAYER.CMS = " + player.cms);
		if (player.cms) {
			AppEvent.on(player, "placeReady", Cms.placeReady);

			$("#ui").append($("<cms ref='cms'></cms>"));
			$("#ui").append($("<popup ref='popup'></popup>"));

			player.cmsnode = $("<div class='cms'></div>");
			$("#ui").append(player.cmsnode);

			$("#player").on("mousedown", function(evt) {
				if (evt.which == 3) {
					Cms.vue.$refs.popup.open(evt.clientX, evt.clientY);
				} else {
					Cms.vue.$refs.cms.$refs.panoedit.open();
				}
			});

			document.addEventListener('contextmenu', function(event) {
				event.preventDefault();
			});
		}
	},

	placeReady: function() {
		Cms.vue.$refs.cms.$refs.panoedit.open();
	},

	afterInit: function() {
		if (player.cms) {
			Cms.saveButton = $("<a href='javascript:void(null);' onclick='Cms.save();'><i class='fa fa-save'></i><Br>Zapisz</a>");
			player.cmsnode.append(Cms.saveButton);			

			Cms.vue = new Vue({
  				el: '#ui'
			});

			Cms.root = Cms.vue.$refs.cms;
		}
	},

	save: function() {
		var elements = [];

		for(var ind in ElementManager.elements) {
			var el = ElementManager.elements[ind];

			if (el.place != undefined && el.place != null && el.place != player.ident) continue;

			var fields = {
				"type": el.type,
				"group": el.group,
				"group_id": el.group_id,
				"folder_wide": el.folderwide,
				"x": el.hpos(),
				"y": el.vpos(),
				"params": JSON.stringify(el.params),
				"uid": el.uid
			};

			if (el.id != undefined) fields.id = el.id;

			elements.push(fields);
		}

		$.post("/cms/index.php?mod=Panorama&action=syncElements&pano=" + player.ident, {"elements" : elements}, function(res) {
			for(var ind in ElementManager.elements) {
				var el = ElementManager.elements[ind];
				if (res.created != undefined) {
					if (el.id == undefined && res.created[el.uid] != undefined) el.id = res.created[el.uid]['id'];
					//if (el.group_id == undefined && res.create[el.uid]['group_id'] != undefined) el.group_id = res.created[el.uid]['group_id'];
				}
			}
			alert("Zapisano zmiany");
		});
	}
}

PluginManager.add(Cms);

//PluginManager.add(SpotEdit);
//PluginManager.add(UIEdit);